import { render, staticRenderFns, recyclableRender, components } from "./u-swipe-action-item.vue?vue&type=template&id=2fea6ae7&scoped=true&filter-modules=eyJ3eHMiOnsidHlwZSI6InNjcmlwdCIsImNvbnRlbnQiOiIiLCJzdGFydCI6MjIyMiwiYXR0cnMiOnsic3JjIjoiLi9pbmRleC53eHMiLCJtb2R1bGUiOiJ3eHMiLCJsYW5nIjoid3hzIn0sImVuZCI6MjIyMn19&"
var renderjs
import script from "./u-swipe-action-item.vue?vue&type=script&lang=js&"
export * from "./u-swipe-action-item.vue?vue&type=script&lang=js&"
import style0 from "./u-swipe-action-item.vue?vue&type=style&index=0&id=2fea6ae7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fea6ae7",
  null,
  false,
  components,
  renderjs
)

/* custom blocks */
import block0 from "./index.wxs?vue&type=custom&index=0&blockType=script&issuerPath=D%3A%5C%E8%B1%86%E7%B1%B3%5ClaborVisitors%5Cnode_modules%5Cuview-ui%5Ccomponents%5Cu-swipe-action-item%5Cu-swipe-action-item.vue&module=wxs&lang=wxs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "node_modules/uview-ui/components/u-swipe-action-item/u-swipe-action-item.vue"
export default component.exports